/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useParams } from "react-router-dom";
import { ModalConfirm } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { showSuccess } from "~/components/Toast";
import { EnvironmentRouteParams, Tool } from "~/models";
import {
  generateActionConfirmText,
  generateActionSuccessText,
  useAxios,
} from "~/tools";
import { UnassignButton } from "./UnassignButton";

type ToolUnassignProps = {
  tool: Tool;
  serviceId: string;
  deleteCallback: () => void;
};

function ToolUnassign({ deleteCallback, serviceId, tool }: ToolUnassignProps) {
  const state = useParams<EnvironmentRouteParams>();
  const { environmentId } = state;
  const [isOpen, setIsOpen] = React.useState(false);
  const { showError } = useShowError();
  const { Axios } = useAxios();

  return (
    <>
      <UnassignButton setIsOpen={setIsOpen} />
      <ModalConfirm
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        confirm={async () => {
          try {
            await Axios().delete(
              `/environments/${environmentId}/services/${serviceId}/tools/${tool.id}`
            );
            setIsOpen(true);
            deleteCallback();
            showSuccess(
              generateActionSuccessText(`The ${tool?.name} Tool`)()(
                "detached"
              )()
            );
          } catch (e) {
            showError(e.response);
          }
          setIsOpen(false);
        }}
        actionLabel="Unassign"
        contentLabel="Unassign Tool"
      >
        {generateActionConfirmText(`${tool?.name} Tool`)("unassign")()}
      </ModalConfirm>
    </>
  );
}

export { ToolUnassign };
